import type { EventName } from "@lit/react";
import { RangeSlider as RangeSliderElement, type RangeSliderEventMap as _RangeSliderEventMap, } from "@vaadin/slider/vaadin-range-slider.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { RangeSliderElement, };
export type RangeSliderEventMap = Readonly<{
    onChange: EventName<_RangeSliderEventMap["change"]>;
    onInput: EventName<_RangeSliderEventMap["input"]>;
    onInvalidChanged: EventName<_RangeSliderEventMap["invalid-changed"]>;
    onValidated: EventName<_RangeSliderEventMap["validated"]>;
    onValueChanged: EventName<_RangeSliderEventMap["value-changed"]>;
}>;
const events = { onChange: "change", onInput: "input", onInvalidChanged: "invalid-changed", onValidated: "validated", onValueChanged: "value-changed" } as RangeSliderEventMap;
export type RangeSliderProps = WebComponentProps<RangeSliderElement, RangeSliderEventMap>;
export const RangeSlider = createComponent({
    elementClass: RangeSliderElement, events, react: React, tagName: "vaadin-range-slider"
});
